import { Controller } from "@hotwired/stimulus"

// Switches a digest diff between the raw markdown diff (the default) and the
// rendered view. The choice isn't remembered.
export default class extends Controller {
  static targets = ["rendered", "raw", "button"]

  toggle() {
    const showRendered = this.renderedTarget.hidden
    this.renderedTarget.hidden = !showRendered
    this.rawTarget.hidden = showRendered
    this.buttonTarget.textContent = showRendered ? "Show raw markdown" : "Show rendered"
    this.buttonTarget.setAttribute("aria-pressed", String(showRendered))
  }
}
